export const softwareSkills = [
    "Beckhoff TwinCAT",
    "DATEV",
    "EPLAN",
    "Fanuc CNC",
    "Heidenhain Steuerung",
    "Inventor",
    "Lexware",
    "Mazak Mazatrol",
    "MS Office",
    "Okuma OSP",
    "Sage 100 / Sage HR",
    "SAP",
    "Siemens SINUMERIK",
    "Siemens STEP 7",
    "Siemens TIA Portal",
    "SolidWorks",
];

export const drivingLicenses = [
    "Klasse B (PKW)",
    "Klasse BE (PKW + Anhänger)",
    "Klasse C (LKW)",
    "Klasse CE (LKW + Anhänger)",
    "Klasse C1 (Leichte LKW)",
    "Klasse C1E (Leichte LKW + Anhänger)",
];

export const additionalSkills = [
    "Ausbilderschein (AEVO)",
    "Baumaschinenführerschein",
    "Brandschutzhelfer",
    "Elektrofachkraft für festgelegte Tätigkeiten (EFKffT)",
    "Erste-Hilfe-Ausbildung",
    "Kranschein",
    "MAG-Schweißerpass",
    "Staplerschein",
    "WIG-Schweißerpass",
];

export const hobbies = [
    "Backen",
    "Camping",
    "Fitnessstudio",
    "Fotografieren",
    "Fußball",
    "Gaming",
    "Gartenarbeit",
    "Grillen",
    "Heimwerken",
    "Kochen",
    "Laufen",
    "Lesen",
    "Musik",
    "Musik hören",
    "Persönlichkeitsentwicklung",
    "Radfahren",
    "Reisen",
    "Wandern",
];

export const languageSkillLevels = [
    {
        label: "Anfänger",
        level: 1,
    },
    {
        label: "Grundkenntnisse",
        level: 2,
    },
    {
        label: "Fortgeschritten",
        level: 3,
    },
    {
        label: "Verhandlungssicher",
        level: 4,
    },
    {
        label: "Muttersprache",
        level: 5,
    },
];

export const languageSkillLevelMap: Record<number, string> = {
    1: "Anfänger",
    2: "Grundkenntnisse",
    3: "Fortgeschritten",
    4: "Verhandlungssicher",
    5: "Muttersprache",
};
